module.exports = __webpack_public_path__ + "static/media/settings.aa23d232.svg";